import numbro from 'numbro';
import { capitalize } from 'vue';

import FeeType from '@/common/enums/FeeType.enum';
import MarginTypesOptions, { IMarginTypesOption } from '@/common/models/margins/MarginTypesOptions';
import { DASH } from '@/globals';
import Validatable from '@/validator/Validatable';
import i18n from '@/vueI18n';

export interface IMarginValueAPI {
  type: string;
  value: number;
  base: 'CPM' | 'BUDGET';
  sequence: number;
  margin_id: number | null;
}

export default class MarginValue extends Validatable {
  type?: IMarginTypesOption;
  value?: number;
  base: 'CPM' | 'BUDGET';

  constructor(type: IMarginTypesOption, value: number, base: 'CPM' | 'BUDGET' = 'CPM') {
    super();
    this.type = type;
    this.value = value;
    this.base = base;
  }
  get valueAsNumber(): number {
    return this.value ? parseFloat(`${this.value}`) : 0;
  }

  get valueFormatted(): string {
    if (!this.value) return DASH;
    if (this.type?.type === FeeType.Percent) {
      return numbro(this.valueAsNumber).format('0,0.00%');
    }
    return i18n.global.n(this.valueAsNumber, 'currency');
  }

  static fromApi(api: IMarginValueAPI): MarginValue {
    return new MarginValue(
      MarginTypesOptions.options().find((option) => option.type === api.type),
      Number(api.value),
      api.base ?? 'CPM',
    );
  }

  toApi(): IMarginValueAPI {
    return {
      margin_id: null,
      type: this.type.type,
      value: this.valueAsNumber,
      base: this.base ?? 'CPM',
      sequence: 1,
    };
  }

  toString(): string {
    const marginTypeName = capitalize(i18n.global.t(this.type.name));
    return `${marginTypeName} – ${this.valueFormatted}`;
  }
}
